import {useContext, useMemo, useEffect, useRef, useState, useCallback} from "react";
//import {data2, data3} from '../../data/data-containers/data-Profile.js';
import {getMainWidth, handelTitle, get_permissions} from '../../utils'
import SecAvatar from './SecAvatar'
import SecName from './SecName'
//import SecNavWrapper from './SecNavWrapper'
import SecSettings from './SecSettings'
import SecInformation from './SecInformation'
//import SecLatest from './SecLatest'
//import SecProjects from './SecProjects'
import './Profile.css'
import {useNavigate, useLocation} from "@tanstack/react-router";
import {toast} from "react-toastify";
import ITag from "../../components/ITag";
import Activity from "./Activity.jsx";
import ItemsForSale from "./ItemsForSale.jsx";
import {Modal2} from "../../components/Modal"
import {AppContext} from "../../App.jsx";
import { useI18n } from '../../i18n/context';
//import Vcl from "../../components/ViewsCommentsLikes/Header.jsx";
import {
    FacebookIcon,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton
} from "react-share";
//import { useAppKit } from '@reown/appkit/react'
import {ViriMultiCallRead} from "../../components/getTokens.js";
import { useAuth } from '../../lib/auth'
import { uploadFile } from '../../lib/api';
import { parseSessionToken, sessionStorageRemove } from '../../lib/window-shim'
import { uploadProxy } from '../../UploadShim';

/**
 * @module containers/Profile
 * @category Containers
 * @description User profile page container component.
 */

/**
 * LiveStream sub-component.
 *
 * Displays embedded YouTube live stream with share buttons and view toggle.
 *
 * @param {object} props
 * @param {object} props.profileInfo - Profile data including liveStream URL and id
 * @param {Function} props.toggleLiveMode - Callback to switch between live/normal view
 * @returns {React.ReactElement|null}
 */
const LiveStream = ({ profileInfo, toggleLiveMode }) => {
    const { t } = useI18n();
    let pn = useLocation().pathname+"/"+profileInfo?.id;
    let title = t("containers.profile.shareTitle", { user: profileInfo?.username });

    if (!profileInfo?.liveStream) return null;

    return(
        <div className="card bg-dark bg-opacity-50 border border-secondary p-3 mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0 text-light">{t('containers.profile.liveStream')}</h6>
                <button className="btn btn-sm btn-outline-light" onClick={toggleLiveMode}>{t('containers.profile.switchView')}</button>
            </div>
            <div className="d-flex justify-content-end gap-3 mb-2">
                <span className="text-light text-sm me-2">{t('containers.profile.shareThisStream')}</span>
                <TwitterShareButton
                    title={title}
                    url={"https://stealthisnft.xyz"+pn}
                    hashtags={[]}
                >
                    <TwitterIcon size="24" round={true}/>
                </TwitterShareButton>
                <FacebookShareButton
                    title={title}
                    url={"https://stealthisnft.xyz"+pn}
                    hashtags={[]}
                >
                    <FacebookIcon size="24" round={true}/>
                </FacebookShareButton>
                <TelegramShareButton
                    title={title}
                    url={"https://stealthisnft.xyz"+pn}
                    hashtags={[]}
                >
                    <TelegramIcon size="24" round={true}/>
                </TelegramShareButton>
            </div>
            <div className="ratio ratio-16x9">
                <iframe
                    src={"https://www.youtube.com/embed/"+profileInfo?.liveStream}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    className="rounded"
                ></iframe>
            </div>
        </div>
    )
}

/**
 * Profile page container component.
 *
 * Displays user profile information including:
 * - Banner and avatar images with upload capability
 * - Username and display name
 * - User bio/information section
 * - Items for sale from the user
 * - Activity feed (comments, likes)
 * - Live stream support (YouTube embed)
 * - Settings modal for profile editing
 *
 * Handles profile image uploads via FormData and targetProxy.
 * Manages permissions (admin or self-only editing).
 * Supports both view and video modes.
 * Fetches profile data from backend API based on URL userID.
 *
 * @module containers/Profile
 * @category Containers
 * @returns {React.ReactElement} Rendered profile page or redirect to sign-in
 */
const ProfileContainer = ({ userId: propUserId, initialProfile, isPrivate }) => {
    const { t } = useI18n();

    const _ac = useContext(AppContext)

    const [profileInfo, setPI] = useState(initialProfile || null);
    const [videoView, svv] = useState(false)
    const [showModal, ssm] = useState(false);
    const [modalTitle, smt] = useState();
    const [uploadRefresh, sur] = useState(0);
    //const [uid, setUid] = useState(null);
    // const [data2, setData2] = useState([]);
    // const [ItemDetailsitemDetails, setID] = useState([])
    const [modalContent, smc] = useState()
    //const {wallet, open, close} = useAppKit()
    const { user: currentProfile } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    let userID = propUserId; // Use the userId prop from route
    let loc = location.pathname;

    let flags = location?.flag;

    if(!flags) flags="";

    // If no userID in prop (e.g., from /profile redirect), try to get from Bearer token format (authKey:uid)
    if (!userID && currentProfile?.account?.id) {
        const id = currentProfile.account.id;
        // Handle both string (with possible colon) and number types
        userID = typeof id === 'string' ? id.split(':')[0] : id.toString();
    }

    const currentId = currentProfile?.account?.id;
    const editAllowed = get_permissions("admin") || (currentId != null && userID != null && currentId.toString() === userID.toString());

    let hdrRef = useRef<HTMLInputElement>(null);

    const upload = useCallback((itype) => {
        if (!hdrRef.current) return;
        (hdrRef.current as any).itype = itype;
        hdrRef.current.click();
    }, []);

    const doUpload = useCallback(async (e, data) => {

        let file = e.target.files[0];
        const isBanner = (hdrRef.current as any)?.itype === "banner";
        const fdd: any = {
            wall: 0,
            _token: null,
            nft_contract: "",
            nft_currentOwner: "0x00",
            isCached: false,
            description: "",
            tocid: 0,
        };
        if (isBanner) {
            fdd.descr = "Banner Pic";
            fdd.filen = file.name;
            fdd.cid = 0;
            fdd.colln = "Banner";
            fdd.bann = true;
        } else {
            fdd.descr = "Avatar Pic";
            fdd.filen = file.name;
            fdd.cid = 0;
            fdd.colln = "Avatar";
        }
        const rawToken = parseSessionToken();
        const parsedToken = (typeof rawToken === 'string') ? (rawToken ? JSON.parse(rawToken) : null) : (rawToken || null);
        fdd.wall = parsedToken?.account?.id;
        fdd._token = parsedToken;
        if(fdd._token?.account?.is_admin) { fdd.wall = profileInfo?.id }
        // handle validations
        //toast("Upload");
        // Send multipart to /api/v1/binupload (multipart: json + blob) for both avatar and banner
        const fd = new FormData();
        fd.append('json', JSON.stringify(fdd));
        fd.append('blob', file);
        await uploadFile(fd);
        sur(Math.random());
    }, [profileInfo]);

    useEffect(()=>{
        if (!profileInfo?.id) return; // Prevent undefined-ID loop
        let x = document.getElementById("banner");
        let y = document.getElementById("avatar_p");
        if(x) {
            x.style.backgroundImage = "url('https://cdn.stealthisnft.xyz/u/" + profileInfo.id + "/profile/banner.jpg?" + uploadRefresh + "')"
        }
        if(y) {
            y.src = "https://cdn.stealthisnft.xyz/u/" + profileInfo.id + "/profile/avatar.jpg?" + uploadRefresh
        }
    }, [profileInfo?.id, uploadRefresh])

    // The component now renders for all users.
    // Private profiles show a message via isPrivate prop.
    // Edit controls only appear for profile owner/admins via editAllowed check.

    const openSettings = useCallback(() => {
        smc(<SecSettings ssm={ssm} edp={profileInfo} spi={setPI}/>)
        smt("Profile Settings")
        ssm(true)
    }, [profileInfo]);

    useEffect(() => {
        // get userID SQL here
        // document.title = 'Profile'
        //getProfile();
        handelTitle('Profile')
        getMainWidth()
    }, [])

    // Removed useEffect that fetched profile data - it's now handled by the route loader
    // The profileInfo prop from the loader provides initial data
    // If needed, we can still refetch with setPI, but initial render is instant

    useEffect(() => {
        if(flags.includes("newuser")){
           // toast.success("Welcome to Viridissima Marketplace! Please spend a moment to set your profile up before exploring!", {autoClose: 10000})
            openSettings();
        }
    }, [flags, openSettings])


    // console.log(typeof(profileInfo.displayname)) // this doesn't work due to the async nature of the db call
//  if(typeof(profileInfo.displayname) !== 'undefined'){
    let cunt = profileInfo?.id;

    function imgErr(e){
        const fbAvatar = "https://cdn.stealthisnft.xyz/u/0/profile/avatar.jpg";
        const fbBanner = "https://cdn.stealthisnft.xyz/u/0/profile/banner.jpg";
        if (e.target.id.includes('avatar')) {
            if (e.target.src === fbAvatar) return;
            e.target.onError = null;
            e.target.src = fbAvatar;
        } else {
            const bg = e.target.style.backgroundImage;
            if (bg && bg.includes(fbBanner)) return;
            e.target.onError = null;
            e.target.style.backgroundImage = `url('${fbBanner}')`;
            e.target.style.backgroundPositionY = "50%";
            e.target.style.minHeight = "200px";
        }
    }

    const toggleLiveMode = useCallback(() => {
            svv(prev => !prev)
    }, [])

    let ulp = location.pathname

    return (

        <>
            {isPrivate ? (
                <div className="main-content position-relative bg-gray-100">
                    <div className="container-fluid py-4">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-8 col-lg-6 text-center">
                                <div className="card bg-gray-100 p-5">
                                    <h2 className="text-light">{t('containers.profile.privateProfile')}</h2>
                                    <p className="mt-3 mb-0 text-light opacity-8">
                                        {t('containers.profile.privateDesc')}
                                    </p>
                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={() => navigate({ to: '/' })}
                                    >
                                        <i className="fas fa-home me-2" />
                                        {t('containers.profile.goToHomepage')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : profileInfo?.id ? (
            <div className="main-content position-relative bg-gray-100">
                <div className="container-fluid">
                    <div key={"ban"+uploadRefresh} id="banner" onError={(e)=>imgErr(e)}
                        className={"pixel-card page-header border-radius-xl mt-1 mb-1 profile-banner" + (videoView ? " video-view" : "")}
                        style={videoView ? {
                            minHeight: "100px"
                        } : {
                            minHeight: "200px"
                        }}>
                        <Modal2 overflow="scroll" modalTitle={modalTitle} content={modalContent} show={showModal}/>
                        {editAllowed ?
                            <button onClick={() => upload("banner")}
                           className="btn btn-sm btn-icon-only bg-gradient-light rounded-circle position-absolute bottom-0 end-0 m-1">
                                <ITag ClassName="fa fa-pen top-0" data-bs-toggle="tooltip" data-bs-placement="top"
                                      title="Edit Image"/>
                            </button> : null }
                    </div>
                    <div className="card-header row mt-n10 mb-4 align-items-center profile-header bg-opacity-50" style={{zIndex: "15"}}>

                        <div className="col-auto ms-3">
                            <SecAvatar sur={sur} key={"ava_"+uploadRefresh} img={cunt} pi={profileInfo} editAllowed={editAllowed} imgErr={imgErr}/>
                        </div>

                        <SecName profileInfo={profileInfo}/>

                    </div>
                </div>

                {/* Main content area */}
                <div className="container-fluid py-1">
                    <div className="profile-content">
                        <div className="profile-sidebar">
                            {videoView && <LiveStream profileInfo={profileInfo} toggleLiveMode={toggleLiveMode} />}
                            <SecInformation editAllowed={editAllowed} profileInfo={profileInfo} settings={openSettings}/>
                            <ItemsForSale userid={userID}/>
                        </div>
                        <div className="profile-main">
                            {!videoView && <LiveStream profileInfo={profileInfo} toggleLiveMode={toggleLiveMode} />}
                            {userID === currentProfile?.account?.id ?
                                <Activity recipientId={userID} showActions={true} userID={userID} profileInfo={profileInfo}
                                          itemHash={ulp}/>
                                :
                                <Activity recipientId={userID} showActions={true} userID={userID} profileInfo={profileInfo}
                                          metaAction={"commented on " + profileInfo?.username + "'s profile"} actionLocation={loc}
                                          itemHash={window.location.href}/>
                            }
                        </div>
                    </div>
                </div>

                <div style={{visibility: "hidden", display: "none"}}>
                    <input ref={hdrRef} id="upload" type="file" onChange={doUpload}/>
                </div>
            </div>
                ) : null}
        </>
    )
    // } else {
    //   return ( <Redirect to='/' /> )
    // }

}

export default ProfileContainer;
